import React from "react";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { AppLayout } from "./components/layout/AppLayout";
import { ToastProvider } from "./components/ToastProvider";
import { PromptProvider } from "./components/PromptDialog";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { FinancePage } from "./pages/FinancePage";
import { CompaniesPage } from "./pages/CompaniesPage";
import { CompanyDetailPage } from "./pages/CompanyDetailPage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { RemoteConfigPage } from "./pages/RemoteConfigPage";
import { AppReleasesPage } from "./pages/AppReleasesPage";
import { SupportPage } from "./pages/SupportPage";
import { BoardPage } from "./pages/BoardPage";
import { MissionControlPage } from "./pages/MissionControlPage";
import { MigrationsPage } from "./pages/MigrationsPage";
import { ReferralsPage } from "./pages/ReferralsPage";
import { SystemHealth } from "./pages/SystemHealth";
import { LogsPage } from "./pages/LogsPage";
import { ClientAccessPage } from "./pages/ClientAccessPage";
import { ResellerClientsPage } from "./pages/ResellerClientsPage";
import { DemoModePage } from "./pages/DemoModePage";
import { isSessionExpired, loadSession } from "./services/api";

function Protected() {
  const session = loadSession();
  if (!session || isSessionExpired(session)) return <Navigate to="/login" replace />;
  return <AppLayout />;
}

function AlreadyAuthed() {
  const session = loadSession();
  if (session && !isSessionExpired(session)) return <Navigate to="/" replace />;
  return <Outlet />;
}

export function App() {
  return (
    <ToastProvider>
      <PromptProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<AlreadyAuthed />}>
              <Route path="/login" element={<LoginPage />} />
            </Route>
            <Route element={<Protected />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/finance" element={<FinancePage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/companies/:id" element={<CompanyDetailPage />} />
              <Route path="/reseller-clients" element={<ResellerClientsPage />} />
              <Route path="/support" element={<SupportPage />} />
              <Route path="/board" element={<BoardPage />} />
              <Route path="/mission-control" element={<MissionControlPage />} />
              <Route path="/migrations" element={<MigrationsPage />} />
              <Route path="/referrals" element={<ReferralsPage />} />
              <Route path="/audit" element={<Navigate to="/logs" replace />} />
              <Route path="/remote-config" element={<RemoteConfigPage />} />
              <Route path="/app-releases" element={<AppReleasesPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/system-health" element={<SystemHealth />} />
              <Route path="/logs" element={<LogsPage />} />
              <Route path="/client-access" element={<ClientAccessPage />} />
              {/* DEV only. On production the API 404s and the page says so. */}
              <Route path="/demo-mode" element={<DemoModePage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </PromptProvider>
    </ToastProvider>
  );
}
